import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./auth/login/Login";
import { Main } from "./main";
import ResetPassword from "./auth/reset-password/ResetPassword";
import ForgotPassword from "./auth/forgot-password/ForgotPassword";
import { Dashboard } from "./dashboard/Dashboard";
import { Users } from "./users/Users";
import { Documents } from "./documents/Documents";
import { Marketing } from "./campaigns/Marketing";
import { Billing } from "./billing/Billing";
import { CustomerSuccess } from "./customer-success/CustomerSuccess";
import { Metasearch } from "./metasearch/Metasearch";
import { OnboardingTracking } from "./onboarding-tracking/OnboardingTracking";
import { CustomerList } from "./crm/CustomerList";
import { CustomerDetail } from "./crm/CustomerDetail";
import ChargeSecurity from "./settings/ChargeSecurity";
import { useCrmEnabled } from "../helpers/hooks/use-crm-enabled";
import { useTrackingHealthEnabled } from "../helpers/hooks/use-tracking-health-enabled";
import { FleetOverview } from "./tracking/health/FleetOverview";
import { HotelDetail } from "./tracking/health/HotelDetail";
import { RunRecord } from "./tracking/health/RunRecord";
import { Engines } from "./tracking/health/Engines";
import { Queues } from "./tracking/health/Queues";
// CustomerNotes and KnowledgeBase are now tabs inside CustomerSuccess

const RoutesList = () => {
  const crmEnabled = useCrmEnabled();
  const trackingHealthEnabled = useTrackingHealthEnabled();

  return (
    <Routes>
      {/** Public routes */}
      <Route path="/">
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
      </Route>
      {/** Protected routes */}
      <Route element={<Main />}>
        <Route path="users" element={<Users />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="documents" element={<Documents />} />
        <Route path="marketing" element={<Marketing />} />
        <Route path="billing" element={<Billing />} />
        <Route path="customer-success" element={<CustomerSuccess />} />
        <Route path="metasearch" element={<Metasearch />} />
        {trackingHealthEnabled ? (
          <>
            {/* Tracking Health (flag-gated): ONE dashboard — the fleet table
                absorbs the onboarding rows, so the old onboarding paths
                redirect into it and old links keep working. */}
            <Route
              path="tracking"
              element={<Navigate to="/tracking/health" replace />}
            />
            <Route
              path="tracking/onboarding"
              element={<Navigate to="/tracking/health" replace />}
            />
            <Route path="tracking/health" element={<FleetOverview />} />
            <Route
              path="tracking/health/hotels/:customerId"
              element={<HotelDetail />}
            />
            {/* The incident thread is flattened onto the hotel page; this
                redirect only keeps old links from dead-ending. */}
            <Route
              path="tracking/health/incidents/:incidentId"
              element={<Navigate to="/tracking/health" replace />}
            />
            <Route path="tracking/health/runs/:runId" element={<RunRecord />} />
            <Route path="tracking/health/engines" element={<Engines />} />
            <Route path="tracking/health/queues" element={<Queues />} />
            <Route
              path="onboarding-tracking"
              element={<Navigate to="/tracking/health" replace />}
            />
          </>
        ) : (
          <Route path="onboarding-tracking" element={<OnboardingTracking />} />
        )}
        <Route path="settings/charge-security" element={<ChargeSecurity />} />
        {crmEnabled && (
          <>
            <Route path="crm/customers" element={<CustomerList />} />
            <Route path="crm/customers/:id" element={<CustomerDetail />} />
            {/* /crm/ask removed — Ask Autumn is now a floating widget mounted
                in Main, reachable from every page. */}
          </>
        )}
        <Route
          index
          element={
            // if loggged in redirect to dashboard
            <Navigate to="/login" />
          }
        />
      </Route>
    </Routes>
  );
};
export default RoutesList;
